const MINUTES_PER_HOUR = 60;
const SECONDS_PER_MINUTE = 60;
const MS_PER_SECOND = 1000;

export const HOUR_IN_MILLI_SECONDS = MINUTES_PER_HOUR * SECONDS_PER_MINUTE * MS_PER_SECOND;

const DAYS_PER_WEEK = 7;
const HOURS_PER_DAY = 24;
export const RECOMMENDATION_TIMEOUT_MS_7_DAYS = HOUR_IN_MILLI_SECONDS * HOURS_PER_DAY * DAYS_PER_WEEK;

//Show recommended characters after even filter applied in some minutes
const HIDE_RECOMMENDATION_DELAY_MINUTES = 20; //Minutes
export const HIDE_RECOMMENDATION_DELAY_MS = HIDE_RECOMMENDATION_DELAY_MINUTES * SECONDS_PER_MINUTE * MS_PER_SECOND;
